import { useTranslation } from 'react-i18next';
import Constants from 'style/constants';
import MonitoringAlert from 'shared/components/monitoring/monitoring-alert/monitoring-alert';
import { MonitoringType } from 'shared/components/monitoring/monitoring-type';

import { System } from 'features/systems/domain/models/system';
import { SystemAlert } from 'features/systems/domain/models/system-alert';
import { SystemAlertType } from 'features/systems/domain/models/system-alert-type';

interface Props {
  system?: System;
}

const SystemMonitoringAlerts = ({ system }: Props) => {
  const { t } = useTranslation('monitoring');

  if (!system?.systemAlerts) {
    return <></>;
  }

  const renderAlert = (alert: SystemAlert) => {
    switch (alert.type) {
      case SystemAlertType.SystemOffline:
        return (
          <MonitoringAlert
            key={alert.type}
            text={t('messages.systemOffline')}
            type={MonitoringType.SystemOffline}
            message={alert.message}
            lastChangedOn={alert.createdOn}
            color={Constants.Colors.error}
          />
        );
      case SystemAlertType.IS32BatteryError:
      case SystemAlertType.IS32CentralError:
      case SystemAlertType.IS32EarthError:
      case SystemAlertType.IS32PowerError:
      case SystemAlertType.IS32Error:
      case SystemAlertType.IS32SystemError:
        return (
          <MonitoringAlert
            key={alert.type}
            text={t('messages.systemMalfunction')}
            type={MonitoringType.SystemMalfunction}
            message={alert.message}
            lastChangedOn={alert.createdOn}
            color={Constants.Colors.error}
          />
        );
      case SystemAlertType.IPUnitConfigurationError:
      case SystemAlertType.IPUnitHighFrequencyError:
      case SystemAlertType.IPUnitLocalBusError:
      case SystemAlertType.IPUnitWirelessG2Error:
      case SystemAlertType.IPUnitWirelessG2InterferenceError:
        return (
          <MonitoringAlert
            key={alert.type}
            text={t('messages.systemMalfunction')}
            type={MonitoringType.SystemWarning}
            message={alert.message}
            lastChangedOn={alert.createdOn}
            color={Constants.Colors.brightOrange}
          />
        );
      default:
        return (
          <MonitoringAlert
            key={alert.type}
            text={t('messages.systemWarning')}
            type={MonitoringType.SystemWarning}
            message={alert.message}
            lastChangedOn={alert.createdOn}
            color={Constants.Colors.brightOrange}
          />
        );
    }
  };

  return <>{system.systemAlerts.map((alert) => renderAlert(alert))}</>;
};

export default SystemMonitoringAlerts;
